import {RouteConfig} from "vue-router";
import Error404 from "@/views/errors/404.vue";

// MasterLayout
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";

// Register
import registerRoutes from "./register";
import defaultRoutes from "./default";
import departmentRoutes from "./department";
import serviceRoutes from "./services";
import Home from "@/views/Home.vue";
import organizationRoutes from "./organization";
import permissionRoutes from "./permission";
import rolesRoutes from "./roles";
import reportRoutes from "./report";
import customRoutesPermissionRoutes from "./customRoutesPermission";
import databaseConnectionRoutes from "./databaseConnection";

// CBS Routes
import CBSAPIGatewayRoutes from "./CBSApiGateway"
import CBSAccountingRoutes from "./CBSAccounting"
import CBSCommissionRoutes from "./CBSCommission"
import CBSPaymentRoutes from "./CBSPayment"
import CBSProductRoutes from "./CBSProduct"
import operationalLogs from "./operational_logs"
import CBSProductRatingRoutes from "./CBSProductRating"
import CBSUserManagementRoutes from "./CBSUserManagement"
import CBSSubscriptionRoutes from "./CBSSubscription"
import CBSInvoice from "./CBSInvoice"

// @ts-ignore
const baseRoutes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin",
    name: 'HomeAdmin',
    component: Home,
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users",
    name: "Users",
    component: () => import("../views/User/UserList.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/add",
    name: "UserAdd",
    component: () => import("../views/User/UserForm.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/edit/:id",
    name: "UserEdit",
    component: () => import("../views/User/UserForm.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/users/view/:id",
    name: "UserView",
    component: () => import("../views/User/UserView.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/profile",
    name: "AuthProfile",
    component: () => import("../views/User/AuthProfile.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/notifications",
    name: "AuthNotifications",
    component: () => import("../views/User/AuthNotifications.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/notifications/:id/show",
    name: "AuthNotificationShow",
    component: () => import("../views/User/AuthNotificationShow.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/update-password",
    name: "AuthChangePassword",
    component: () => import("../views/User/UpdatePassword.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/auth/ext/change-password",
    name: "UserPasswordReset",
    component: () => import("../views/User/UserPasswordReset.vue"),
    meta: {layout: MasterLayout, requireAuth: true},
  },
  {
    path: "/admin/snmps",
    name: "SNMPList",
    component: () => import("../views/SNMP/SNMPList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/snmps/add",
    name: "SNMPAdd",
    component: () => import("../views/SNMP/SNMPForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/snmps/:id/edit",
    name: "SNMPEdit",
    component: () => import("../views/SNMP/SNMPForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/snmps/:id/show",
    name: "SNMPShow",
    component: () => import("../views/SNMP/SNMPShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/dynamic_domain_names",
    name: "DynamicDomainNameList",
    component: () => import("../views/DynamicDomainName/DynamicDomainNameList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/dynamic_domain_names/add",
    name: "DynamicDomainNameAdd",
    component: () => import("../views/DynamicDomainName/DynamicDomainNameForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/dynamic_domain_names/:id/edit",
    name: "DynamicDomainNameEdit",
    component: () => import("../views/DynamicDomainName/DynamicDomainNameForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/dynamic_domain_names/:id/show",
    name: "DynamicDomainNameShow",
    component: () => import("../views/DynamicDomainName/DynamicDomainNameShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/tcp_mss_values",
    name: "TCPMSSValueList",
    component: () => import("../views/TCPMSSValue/TCPMSSValueList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/tcp_mss_values/add",
    name: "TCPMSSValueAdd",
    component: () => import("../views/TCPMSSValue/TCPMSSValueForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/tcp_mss_values/:id/edit",
    name: "TCPMSSValueEdit",
    component: () => import("../views/TCPMSSValue/TCPMSSValueForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/tcp_mss_values/:id/show",
    name: "TCPMSSValueShow",
    component: () => import("../views/TCPMSSValue/TCPMSSValueShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/dns_bindings",
    name: "DNSBindingList",
    component: () => import("../views/DNSBinding/DNSBindingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/dns_bindings/add",
    name: "DNSBindingAdd",
    component: () => import("../views/DNSBinding/DNSBindingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/dns_bindings/:id/edit",
    name: "DNSBindingEdit",
    component: () => import("../views/DNSBinding/DNSBindingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/dns_bindings/:id/show",
    name: "DNSBindingShow",
    component: () => import("../views/DNSBinding/DNSBindingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_servers",
    name: "OpenVPNServerList",
    component: () => import("../views/OpenVPNServer/OpenVPNServerList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_servers/add",
    name: "OpenVPNServerAdd",
    component: () => import("../views/OpenVPNServer/OpenVPNServerForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_servers/:id/edit",
    name: "OpenVPNServerEdit",
    component: () => import("../views/OpenVPNServer/OpenVPNServerForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_servers/:id/show",
    name: "OpenVPNServerShow",
    component: () => import("../views/OpenVPNServer/OpenVPNServerShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_clients",
    name: "OpenVPNClientList",
    component: () => import("../views/OpenVPNClient/OpenVPNClientList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_clients/add",
    name: "OpenVPNClientAdd",
    component: () => import("../views/OpenVPNClient/OpenVPNClientForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_clients/:id/edit",
    name: "OpenVPNClientEdit",
    component: () => import("../views/OpenVPNClient/OpenVPNClientForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_clients/:id/show",
    name: "OpenVPNClientShow",
    component: () => import("../views/OpenVPNClient/OpenVPNClientShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_usages",
    name: "OPENVPNUsageList",
    component: () => import("../views/OPENVPNUsage/OPENVPNUsageList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_usages/add",
    name: "OPENVPNUsageAdd",
    component: () => import("../views/OPENVPNUsage/OPENVPNUsageForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_usages/:id/edit",
    name: "OPENVPNUsageEdit",
    component: () => import("../views/OPENVPNUsage/OPENVPNUsageForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_usages/:id/show",
    name: "OPENVPNUsageShow",
    component: () => import("../views/OPENVPNUsage/OPENVPNUsageShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_histories",
    name: "OPENVPNHistoryList",
    component: () => import("../views/OPENVPNHistory/OPENVPNHistoryList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_histories/add",
    name: "OPENVPNHistoryAdd",
    component: () => import("../views/OPENVPNHistory/OPENVPNHistoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_histories/:id/edit",
    name: "OPENVPNHistoryEdit",
    component: () => import("../views/OPENVPNHistory/OPENVPNHistoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/open_vpn_histories/:id/show",
    name: "OPENVPNHistoryShow",
    component: () => import("../views/OPENVPNHistory/OPENVPNHistoryShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/adv_port_forwardings",
    name: "AdvPortForwardingList",
    component: () => import("../views/AdvPortForwarding/AdvPortForwardingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/adv_port_forwardings/add",
    name: "AdvPortForwardingAdd",
    component: () => import("../views/AdvPortForwarding/AdvPortForwardingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/adv_port_forwardings/:id/edit",
    name: "AdvPortForwardingEdit",
    component: () => import("../views/AdvPortForwarding/AdvPortForwardingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/adv_port_forwardings/:id/show",
    name: "AdvPortForwardingShow",
    component: () => import("../views/AdvPortForwarding/AdvPortForwardingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/port_forwarding",
    name: "PortForwardingList",
    component: () => import("../views/PortForwarding/PortForwardingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/port_forwarding/add",
    name: "PortForwardingAdd",
    component: () => import("../views/PortForwarding/PortForwardingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/port_forwarding/:id/edit",
    name: "PortForwardingEdit",
    component: () => import("../views/PortForwarding/PortForwardingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/port_forwarding/:id/show",
    name: "PortForwardingShow",
    component: () => import("../views/PortForwarding/PortForwardingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/routing_static",
    name: "RoutingStaticList",
    component: () => import("../views/RoutingStatic/RoutingStaticList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_static/add",
    name: "RoutingStaticAdd",
    component: () => import("../views/RoutingStatic/RoutingStaticForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_static/:id/edit",
    name: "RoutingStaticEdit",
    component: () => import("../views/RoutingStatic/RoutingStaticForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_static/:id/show",
    name: "RoutingStaticShow",
    component: () => import("../views/RoutingStatic/RoutingStaticShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_static/:id/edit?copy=:isCopy",
    name: "RoutingStaticCopy",
    component: () => import("../views/RoutingStatic/RoutingStaticForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/vpn_pools",
    name: "VPNPoolList",
    component: () => import("../views/VPNPool/VPNPoolList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/vpn_pools/add",
    name: "VPNPoolAdd",
    component: () => import("../views/VPNPool/VPNPoolForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/vpn_pools/:id/edit",
    name: "VPNPoolEdit",
    component: () => import("../views/VPNPool/VPNPoolForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/vpn_pools/:id/show",
    name: "VPNPoolShow",
    component: () => import("../views/VPNPool/VPNPoolShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/create_user_profiles",
    name: "CreateUserProfileList",
    component: () => import("../views/CreateUserProfile/CreateUserProfileList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/create_user_profiles/add",
    name: "CreateUserProfileAdd",
    component: () => import("../views/CreateUserProfile/CreateUserProfileForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/create_user_profiles/:id/edit",
    name: "CreateUserProfileEdit",
    component: () => import("../views/CreateUserProfile/CreateUserProfileForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/create_user_profiles/:id/show",
    name: "CreateUserProfileShow",
    component: () => import("../views/CreateUserProfile/CreateUserProfileShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/pre_shared_key",
    name: "PresharedKey",
    component: () => import("../views/CreateUserProfile/PresharedKey.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/connected_users",
    name: "ConnectedUserList",
    component: () => import("../views/ConnectedUser/ConnectedUserList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/connected_users/add",
    name: "ConnectedUserAdd",
    component: () => import("../views/ConnectedUser/ConnectedUserForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/connected_users/:id/edit",
    name: "ConnectedUserEdit",
    component: () => import("../views/ConnectedUser/ConnectedUserForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/connected_users/:id/show",
    name: "ConnectedUserShow",
    component: () => import("../views/ConnectedUser/ConnectedUserShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/macbinding",
    name: "MacbindingList",
    component: () => import("../views/Macbinding/MacbindingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/macbinding/add",
    name: "MacbindingAdd",
    component: () => import("../views/Macbinding/MacbindingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/macbinding/:id/edit",
    name: "MacbindingEdit",
    component: () => import("../views/Macbinding/MacbindingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/macbinding/:id/show",
    name: "MacbindingShow",
    component: () => import("../views/Macbinding/MacbindingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/macbinding_violations",
    name: "MacbindingViolationList",
    component: () => import("../views/MacbindingViolation/MacbindingViolationList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/addFromDeviceList",
    name: "AddFromDeviceList",
    component: () => import("../views/Macbinding/AddFromDeviceList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/next_hop_groups",
    name: "NextHopGroupList",
    component: () => import("../views/NextHopGroup/NextHopGroupList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/next_hop_groups/add",
    name: "NextHopGroupAdd",
    component: () => import("../views/NextHopGroup/NextHopGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/next_hop_groups/:id/edit",
    name: "NextHopGroupEdit",
    component: () => import("../views/NextHopGroup/NextHopGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/next_hop_groups/:id/show",
    name: "NextHopGroupShow",
    component: () => import("../views/NextHopGroup/NextHopGroupShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/pbr_mapping",
    name: "PBRMappingList",
    component: () => import("../views/PBRMapping/PBRMappingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/pbr_mapping/add",
    name: "PBRMappingAdd",
    component: () => import("../views/PBRMapping/PBRMappingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/pbr_mapping/:id/edit",
    name: "PBRMappingEdit",
    component: () => import("../views/PBRMapping/PBRMappingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/pbr_mapping/:id/show",
    name: "PBRMappingShow",
    component: () => import("../views/PBRMapping/PBRMappingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/pbr_interfaces",
    name: "PBRInterfaceList",
    component: () => import("../views/PBRInterface/PBRInterfaceList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/pbr_interfaces/add",
    name: "PBRInterfaceAdd",
    component: () => import("../views/PBRInterface/PBRInterfaceForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/pbr_interfaces/:id/edit",
    name: "PBRInterfaceEdit",
    component: () => import("../views/PBRInterface/PBRInterfaceForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/pbr_interfaces/:id/show",
    name: "PBRInterfaceShow",
    component: () => import("../views/PBRInterface/PBRInterfaceShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_areas",
    name: "RoutingAreaList",
    component: () => import("../views/RoutingArea/RoutingAreaList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_areas/add",
    name: "RoutingAreaAdd",
    component: () => import("../views/RoutingArea/RoutingAreaForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_areas/:id/edit",
    name: "RoutingAreaEdit",
    component: () => import("../views/RoutingArea/RoutingAreaForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_areas/:id/show",
    name: "RoutingAreaShow",
    component: () => import("../views/RoutingArea/RoutingAreaShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/routing_ospf",
    name: "RoutingOSPFList",
    component: () => import("../views/RoutingOSPF/RoutingOSPFList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_ospf/add",
    name: "RoutingOSPFAdd",
    component: () => import("../views/RoutingOSPF/RoutingOSPFForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_ospf/:id/edit",
    name: "RoutingOSPFEdit",
    component: () => import("../views/RoutingOSPF/RoutingOSPFForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_ospf/:id/show",
    name: "RoutingOSPFShow",
    component: () => import("../views/RoutingOSPF/RoutingOSPFShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/tunnelconfigurations",
    name: "TunnelConfigurationList",
    component: () => import("../views/TunnelConfiguration/TunnelConfigurationList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/tunnelconfigurations/add",
    name: "TunnelConfigurationAdd",
    component: () => import("../views/TunnelConfiguration/TunnelConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/tunnelconfigurations/:id/edit",
    name: "TunnelConfigurationEdit",
    component: () => import("../views/TunnelConfiguration/TunnelConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/tunnelconfigurations/:id/show",
    name: "TunnelConfigurationShow",
    component: () => import("../views/TunnelConfiguration/TunnelConfigurationShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/tunnelconfigurations/:id/edit?copy=:isCopy",
    name: "TunnelConfigurationCopy",
    component: () => import("../views/TunnelConfiguration/TunnelConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/acl_rules",
    name: "ACLRuleList",
    component: () => import("../views/ACLRule/ACLRuleList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/acl_rules/add",
    name: "ACLRuleAdd",
    component: () => import("../views/ACLRule/ACLRuleForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/acl_rules/:id/edit",
    name: "ACLRuleEdit",
    component: () => import("../views/ACLRule/ACLRuleForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/acl_rules/:id/show",
    name: "ACLRuleShow",
    component: () => import("../views/ACLRule/ACLRuleShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/acl_rules/:id/edit?copy=:isCopy",
    name: "ACLRuleCopy",
    component: () => import("../views/ACLRule/ACLRuleForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/devices",
    name: "DeviceList",
    component: () => import("../views/Device/DeviceList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/devices/add",
    name: "DeviceAdd",
    component: () => import("../views/Device/DeviceForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/devices/:id/edit",
    name: "DeviceEdit",
    component: () => import("../views/Device/DeviceForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/devices/:id/show",
    name: "DeviceShow",
    component: () => import("../views/Device/DeviceShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/rules",
    name: "RuleList",
    component: () => import("../views/Rule/RuleList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/addDeviceRule/:id/:group_name/:Device_MAC/:accountId/:ip_address",
    name: "addDeviceRule",
    component: () => import("../views/Rule/AddDeviceRule.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/addDeviceRule/:id/:group_name/:accountId",
    name: "addGroupRule",
    component: () => import("../views/Rule/AddDeviceRule.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
{
    path: "/admin/addDeviceTimeProfile/:id/:Device_MAC/:accountId/:timeCategoryId",
    name: "addDeviceTimeProfile",
    component: () => import("../views/TimeProfileInfo/TimeProfileInfoForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/addGroupTimeProfile/:id/:group_name/:accountId/:timeCategoryId",
    name: "addGroupTimeProfile",
    component: () => import("../views/TimeProfileInfo/TimeProfileInfoForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ddos",
    name: "DDoS",
    component: () => import("../views/GeneralSecurity/DDoS.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  // {
  //   path: "/admin/rules/add",
  //   name: "RuleAdd",
  //   component: () => import("../views/Rule/RuleForm.vue"),
  //   meta: {
  //     requireAuth: true, layout: MasterLayout,
  //   },
  // },
  // {
  //   path: "/admin/rules/:id/edit",
  //   name: "RuleEdit",
  //   component: () => import("../views/Rule/RuleForm.vue"),
  //   meta: {
  //     requireAuth: true, layout: MasterLayout,
  //   },
  // },
  // {
  //   path: "/admin/rules/:id/show",
  //   name: "RuleShow",
  //   component: () => import("../views/Rule/RuleShow.vue"),
  //   meta: {
  //     requireAuth: true, layout: MasterLayout,
  //   },
  // },
  {
    path: "/admin/group_info",
    name: "GroupInfoList",
    component: () => import("../views/GroupInfo/GroupInfoList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/group_info/add",
    name: "GroupInfoAdd",
    component: () => import("../views/GroupInfo/GroupInfoForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/group_info/:id/edit",
    name: "GroupInfoEdit",
    component: () => import("../views/GroupInfo/GroupInfoForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/group_info/:id/show",
    name: "GroupInfoShow",
    component: () => import("../views/GroupInfo/GroupInfoShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/nat_overloads",
    name: "NATOverloadList",
    component: () => import("../views/NATOverload/NATOverloadList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/nat_overloads/add",
    name: "NATOverloadAdd",
    component: () => import("../views/NATOverload/NATOverloadForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/nat_overloads/:id/edit",
    name: "NATOverloadEdit",
    component: () => import("../views/NATOverload/NATOverloadForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/nat_overloads/:id/edit?copy=:isCopy",
    name: "NATOverloadCopy",
    component: () => import("../views/NATOverload/NATOverloadForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/nat_overloads/:id/show",
    name: "NATOverloadShow",
    component: () => import("../views/NATOverload/NATOverloadShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/interface_configurations",
    name: "InterfaceConfigurationList",
    component: () => import("../views/InterfaceConfiguration/InterfaceConfigurationList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/interface_configurations/add",
    name: "InterfaceConfigurationAdd",
    component: () => import("../views/InterfaceConfiguration/InterfaceConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/interface_configurations/:id/edit",
    name: "InterfaceConfigurationEdit",
    component: () => import("../views/InterfaceConfiguration/InterfaceConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/interface_configurations/:id/show",
    name: "InterfaceConfigurationShow",
    component: () => import("../views/InterfaceConfiguration/InterfaceConfigurationShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/net_flows",
    name: "NetFlowList",
    component: () => import("../views/NetFlow/NetFlowList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/net_flows/add",
    name: "NetFlowAdd",
    component: () => import("../views/NetFlow/NetFlowForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/net_flows/:id/edit",
    name: "NetFlowEdit",
    component: () => import("../views/NetFlow/NetFlowForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/net_flows/:id/show",
    name: "NetFlowShow",
    component: () => import("../views/NetFlow/NetFlowShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/qos",
    name: "QoList",
    component: () => import("../views/Qo/QoList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/qos/add",
    name: "QoAdd",
    component: () => import("../views/Qo/QoForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/qos/:id/edit",
    name: "QoEdit",
    component: () => import("../views/Qo/QoForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/qos/:id/show",
    name: "QoShow",
    component: () => import("../views/Qo/QoShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wan_status",
    name: "WanStatusList",
    component: () => import("../views/WanStatus/WanStatusList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wan_status/add",
    name: "WanStatusAdd",
    component: () => import("../views/WanStatus/WanStatusForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wan_status/:id/edit",
    name: "WanStatusEdit",
    component: () => import("../views/WanStatus/WanStatusForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wan_status/:id/show",
    name: "WanStatusShow",
    component: () => import("../views/WanStatus/WanStatusShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/interface_settings",
    name: "InterfaceSettingList",
    component: () => import("../views/InterfaceSetting/InterfaceSettingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/interface_settings/add",
    name: "InterfaceSettingAdd",
    component: () => import("../views/InterfaceSetting/InterfaceSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/interface_settings/:id/edit",
    name: "InterfaceSettingEdit",
    component: () => import("../views/InterfaceSetting/InterfaceSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/interface_settings/:id/show",
    name: "InterfaceSettingShow",
    component: () => import("../views/InterfaceSetting/InterfaceSettingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/change_log",
    name: "ChangeLogList",
    component: () => import("../views/ChangeLog/ChangeLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/change_log/add",
    name: "ChangeLogAdd",
    component: () => import("../views/ChangeLog/ChangeLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/change_log/:id/edit",
    name: "ChangeLogEdit",
    component: () => import("../views/ChangeLog/ChangeLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/change_log/:id/show",
    name: "ChangeLogShow",
    component: () => import("../views/ChangeLog/ChangeLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
{
    path: "/admin/wifisetting",
    name: "WifiMasterList",
    component: () => import("../views/WifiMaster/WifiMasterList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/wifisetting/add",
    name: "WifiMasterAdd",
    component: () => import("../views/WifiMaster/WifiMasterForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifisetting/:id/edit",
    name: "WifiMasterEdit",
    component: () => import("../views/WifiMaster/WifiMasterForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/reboot",
    name: "RebootForm",
    component: () => import("../views/Reboot/RebootForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/fwUpdateInfo",
    name: "UpdateFormwareForm",
    component: () => import("../views/Reboot/UpdateFormwareForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_masters",
    name: "WifiMasterList",
    component: () => import("../views/WifiMaster/WifiMasterList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_masters/add",
    name: "WifiMasterAdd",
    component: () => import("../views/WifiMaster/WifiMasterForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_masters/:id/edit",
    name: "WifiMasterEdit",
    component: () => import("../views/WifiMaster/WifiMasterForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_masters/:id/show",
    name: "WifiMasterShow",
    component: () => import("../views/WifiMaster/WifiMasterShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/accounts",
    name: "AccountList",
    component: () => import("../views/Account/AccountList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/accounts/add",
    name: "AccountAdd",
    component: () => import("../views/Account/AccountForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/accounts/:id/edit",
    name: "AccountEdit",
    component: () => import("../views/Account/AccountForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/accounts/:id/show",
    name: "AccountShow",
    component: () => import("../views/Account/AccountShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/notification_settings",
    name: "NotificationSettingList",
    component: () => import("../views/NotificationSetting/NotificationSettingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/notification_settings/add",
    name: "NotificationSettingAdd",
    component: () => import("../views/NotificationSetting/NotificationSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/notification_settings/:id/edit",
    name: "NotificationSettingEdit",
    component: () => import("../views/NotificationSetting/NotificationSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/notification_settings/:id/show",
    name: "NotificationSettingShow",
    component: () => import("../views/NotificationSetting/NotificationSettingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },

  },
  {
    path: "/admin/download_configs",
    name: "DownloadList",
    component: () => import("../views/NotificationSetting/DownloadList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_ospf_neighbor_infos",
    name: "OSPFNeighborList",
    component: () => import("../views/TunnelConfiguration/OSPFNeighborList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_ip_infos",
    name: "IPRouteList",
    component: () => import("../views/TunnelConfiguration/IPRouteList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_bgp_infos",
    name: "IPRouteList",
    component: () => import("../views/TunnelConfiguration/BGPList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/occurances",
    name: "OccuranceList",
    component: () => import("../views/Occurance/OccuranceList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/occurances/add",
    name: "OccuranceAdd",
    component: () => import("../views/Occurance/OccuranceForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/occurances/:id/edit",
    name: "OccuranceEdit",
    component: () => import("../views/Occurance/OccuranceForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/occurances/:id/show",
    name: "OccuranceShow",
    component: () => import("../views/Occurance/OccuranceShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
    {
    path: "/admin/reboot",
    name: "RebootForm",
    component: () => import("../views/Reboot/RebootForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/activationkeys",
    name: "ActivationKeyList",
    component: () => import("../views/ActivationKey/ActivationKeyList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/activation_pins",
    name: "ActivationPinList",
    component: () => import("../views/ActivationKey/ActivationPinList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/activation_pins/add",
    name: "ActivationPinAdd",
    component: () => import("../views/ActivationKey/ActivationPinForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/activation_pins/:id/edit",
    name: "ActivationPinEdit",
    component: () => import("../views/ActivationKey/ActivationPinForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/voip",
    name: "VoipEdit",
    component: () => import("../views/Voip/VoipEdit.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routerList/:searchtype/:searchparam",
    name: "RouterList",
    component: () => import("../views/ActivationKey/ActivationKeyList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/device-details/:userId/:accountId",
    name: "DeviceDetails",
    component: () => import("../views/Device/CustomDeviceList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/deviceUsage/:accountId/:device_mac",
    name: "DeviceUsage",
    component: () => import("../views/Device/DeviceUsage.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/update_configurations",
    name: "UpdateConfiguration",
    component: () => import("../views/UpdateConfiguration/UpdateConfiguration.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/update_firmware",
    name: "UpdateFirmware",
    component: () => import("../views/UpdateConfiguration/UpdateFirmware.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/summary_usages",
    name: "SummaryUsageList",
    component: () => import("../views/SummaryUsage/SummaryUsageList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/summary_usages/add",
    name: "SummaryUsageAdd",
    component: () => import("../views/SummaryUsage/SummaryUsageForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/summary_usages/:id/edit",
    name: "SummaryUsageEdit",
    component: () => import("../views/SummaryUsage/SummaryUsageForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/summary_usages/:id/show",
    name: "SummaryUsageShow",
    component: () => import("../views/SummaryUsage/SummaryUsageShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/audra_status",
    name: "AudraStatusList",
    component: () => import("../views/Others/AudraStatusList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ipsec_transport_status",
    name: "IPSECTransportStatusList",
    component: () => import("../views/Others/IPSECTransportStatusList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/summary_occurance/:category",
    name: "SummaryOccurance",
    component: () => import("../views/SummaryOccurance/SummaryOccuranceList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/ddos_info",
    name: "DDoSInfo",
    component: () => import("../views/DDoSInfo/DDoSInfo.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/session_logs",
    name: "SessionLog",
    component: () => import("../views/Report/SessionLog.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/applicationupdates",
    name: "ApplicationUpdateList",
    component: () => import("../views/ApplicationUpdate/ApplicationUpdateList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/applicationupdates/add",
    name: "ApplicationUpdateAdd",
    component: () => import("../views/ApplicationUpdate/ApplicationUpdateForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/applicationupdates/:id/edit",
    name: "ApplicationUpdateEdit",
    component: () => import("../views/ApplicationUpdate/ApplicationUpdateForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/applicationupdates/:id/show",
    name: "ApplicationUpdateShow",
    component: () => import("../views/ApplicationUpdate/ApplicationUpdateShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_configurations_2gh",
    name: "WifiConfiguration2GHz",
    component: () => import("../views/WifiConfiguration/WifiConfiguration.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_configurations_2gh/add",
    name: "WifiConfiguration2GHzAdd",
    component: () => import("../views/WifiConfiguration/WifiConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_configurations_2gh/:id/edit",
    name: "WifiConfiguration2GHzEdit",
    component: () => import("../views/WifiConfiguration/WifiConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_configurations_5gh",
    name: "WifiConfiguration5GHz",
    component: () => import("../views/WifiConfiguration/WifiConfiguration.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_configurations_5gh/add",
    name: "WifiConfiguration5GHzAdd",
    component: () => import("../views/WifiConfiguration/WifiConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/wifi_configurations_5gh/:id/edit",
    name: "WifiConfiguration5GHzEdit",
    component: () => import("../views/WifiConfiguration/WifiConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/provisions",
    name: "ProvisionList",
    component: () => import("../views/Provision/ProvisionList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/provisions/add",
    name: "ProvisionAdd",
    component: () => import("../views/Provision/ProvisionForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/provisions/:id/edit",
    name: "ProvisionEdit",
    component: () => import("../views/Provision/ProvisionForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/provisions/:id/view",
    name: "ProvisionView",
    component: () => import("../views/Provision/ProvisionView.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
    {
    path: "/admin/provision_history",
    name: "ProvisionHistory",
    component: () => import("../views/ProvisionHistory/ProvisionHistory.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
   {
    path: "/admin/application_alias",
    name: "ApplicationAliasList",
    component: () => import("../views/ApplicationAlias/ApplicationAliasList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
    {
    path: "/admin/application_alias/add",
    name: "ApplicationAliasAdd",
    component: () => import("../views/ApplicationAlias/ApplicationAliasForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
    {
    path: "/admin/application_alias/:id/edit",
    name: "ApplicationAliasEdit",
    component: () => import("../views/ApplicationAlias/ApplicationAliasForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/predefine_groups",
    name: "PredefineGroupList",
    component: () => import("../views/PredefineGroup/PredefineGroupList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/predefine_groups/add",
    name: "PredefineGroupAdd",
    component: () => import("../views/PredefineGroup/PredefineGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/predefine_groups/:id/edit",
    name: "PredefineGroupEdit",
    component: () => import("../views/PredefineGroup/PredefineGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/reset",
    name: "Reset",
    component: () => import("../views/Configurations/Reset.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_prefix_list",
    name: "RoutingPrefixList",
    component: () => import("../views/RoutingPrefixList/RoutingPrefixList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/timezonewise_configurations",
    name: "TimezonewiseConfigurationList",
    component: () => import("../views/TimezonewiseConfiguration/TimezonewiseConfigurationList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/timezonewise_configurations/add",
    name: "TimezonewiseConfigurationAdd",
    component: () => import("../views/TimezonewiseConfiguration/TimezonewiseConfigurationForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_prefix_list/add",
    name: "RoutingPrefixAdd",
    component: () => import("../views/RoutingPrefixList/RoutingPrefixListForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_prefix_list/:id/edit",
    name: "RoutingPrefixListEdit",
    component: () => import("../views/RoutingPrefixList/RoutingPrefixListForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_route_map",
    name: "RoutingRouteMapList",
    component: () => import("../views/RoutingRouteMap/RoutingRouteMapList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_route_map/add",
    name: "RoutingRouteMapAdd",
    component: () => import("../views/RoutingRouteMap/RoutingRouteMapForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_route_map/:id/edit",
    name: "RoutingRouteMapEdit",
    component: () => import("../views/RoutingRouteMap/RoutingRouteMapForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_bgp_routers/add",
    name: "RoutingBGPRouterAdd",
    component: () => import("../views/RoutingGroup/RoutingBGPRouterForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_bgp_routers/:id/edit",
    name: "RoutingBGPRouterEdit",
    component: () => import("../views/RoutingGroup/RoutingBGPRouterForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_networks/add",
    name: "RoutingNetworkAdd",
    component: () => import("../views/RoutingGroup/RoutingNetworkForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_networks/:id/edit",
    name: "RoutingNetworkEdit",
    component: () => import("../views/RoutingGroup/RoutingNetworkForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_peer_groups/add",
    name: "RoutingPeerGroupAdd",
    component: () => import("../views/RoutingGroup/RoutingPeerGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_peer_groups/:id/edit",
    name: "RoutingPeerGroupEdit",
    component: () => import("../views/RoutingGroup/RoutingPeerGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_peerings/add",
    name: "RoutingPeeringAdd",
    component: () => import("../views/RoutingGroup/RoutingPeeringForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_peerings/:id/edit",
    name: "RoutingPeeringEdit",
    component: () => import("../views/RoutingGroup/RoutingPeeringForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/routing_groups",
    name: "RoutingGroupList",
    component: () => import("../views/RoutingGroup/RoutingGroupList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  //##Routes##//
];

const routes = baseRoutes.concat(
  registerRoutes,
  defaultRoutes,
  departmentRoutes,
  serviceRoutes,
  organizationRoutes,
  permissionRoutes,
  rolesRoutes,
  operationalLogs,
  reportRoutes,
  customRoutesPermissionRoutes,
  databaseConnectionRoutes,

  // CBS Routes
  CBSAPIGatewayRoutes,
  CBSAccountingRoutes,
  CBSCommissionRoutes,
  CBSPaymentRoutes,
  CBSProductRoutes,
  CBSProductRatingRoutes,
  CBSUserManagementRoutes,
  CBSSubscriptionRoutes,
  CBSInvoice
)

export default routes
